import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/companies/actions";
import {
  ACCOUNTING,
  CAN_ADD_COMPANIES,
  CAN_UPDATE_COMPANIES,
  QUALITY_CONTROL
} from "MODULES/users/constants";
import {
  form,
  Form as AppForm,
  FormInput,
  Select,
  PhoneNumberField,
  CageField
} from "MODULES/shared/components/Forms";
import { DashedSeparator } from "MODULES/shared/components";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { CAGE, CLASSIFIED_MEMO, IMPORTANT_MEMO } from "MODULES/parts/constants";
import { properCase } from "LIB/formatters/text";
import { disabledUnless as authorized } from "MODULES/shared/decorators";
import { toOptions } from "LIB/forms";
import { NAME, PHONE } from "APP_ROOT/constants";
import { hasAnyOfRoles, hasPermission } from "MODULES/users/helpers";
import validate from "./validate";
import { COMPANY_TYPE, COMPANY_TYPES, FAX, WEBSITE } from "../../constants";

const CompanyNameField = authorized(
  user =>
    hasAnyOfRoles(user.toJS(), [ACCOUNTING, QUALITY_CONTROL]) ||
    hasPermission(user.toJS(), [CAN_ADD_COMPANIES, CAN_UPDATE_COMPANIES])
)(({ disabled }) => (
  <div className="col-md-6">
    <Field
      name={NAME}
      component={FormInput}
      label={properCase(NAME)}
      inputProps={{ disabled }}
      required
    />
  </div>
));

export function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <div>
          <Field
            name={COMPANY_TYPE}
            component={Select}
            label="Type"
            options={toOptions(COMPANY_TYPES)}
          />
          <DashedSeparator />
        </div>
        <FormRow>
          <CompanyNameField />
          <Col md={6}>
            <CageField
              name={CAGE}
              component={FormInput}
              label={properCase(CAGE)}
            />
          </Col>
        </FormRow>
        <DashedSeparator />
        <FormRow>
          <Col md={4}>
            <PhoneNumberField
              name={PHONE}
              component={FormInput}
              label={properCase(PHONE)}
            />
          </Col>
          <Col md={4}>
            <PhoneNumberField
              name={FAX}
              component={FormInput}
              label={properCase(FAX)}
            />
          </Col>
          <Col md={4}>
            <Field
              name={WEBSITE}
              component={FormInput}
              label={properCase(WEBSITE)}
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={6}>
            <Field
              name={IMPORTANT_MEMO}
              component={FormInput}
              label={properCase(IMPORTANT_MEMO)}
            />
          </Col>
          <Col md={6}>
            <Field
              name={CLASSIFIED_MEMO}
              component={FormInput}
              label={properCase(CLASSIFIED_MEMO)}
            />
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, { onSubmit: actions.update })(
  form({
    form: "editCompany",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/companies/components/EditCompany/Form.jsx